import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteModal } from "../../../../../Settings/helpers/useDeleteModal";
import { useDeleteTimeSheet } from "../../../../api/useDeleteTimeSheet";
import { useDateFilters } from "../../../../hooks/useDateFilters";
import useApi from "../../../../../../utils/api";
import { formatTimeSheetParams } from "../../../../api/helpers";
import { useActionWithAccess } from "../../../../../../utils/hooks/access";

export const useRemoveActions = ({ refetch, setState, filters, userId, isMyTimesheet }) => {
    const { t } = useTranslation();
    const { from, to } = useDateFilters();
    const { authGet } = useApi();

    const {
        remove: baseRemove,
        removeMany: baseRemoveMany,
    } = useDeleteTimeSheet();

    const removeOne = useActionWithAccess(
        useCallback((id) => {
            baseRemove(id, async (id) => {
                return authGet(`/time-sheet/my-team`, {
                    params: {
                        ...formatTimeSheetParams({
                            from,
                            to,
                            filters
                        }),
                        userId,
                    },
                }).then(async (response) => {
                    await refetch(response);
                    setState((prev) => ({
                        ...prev,
                        data: prev?.data?.filter(
                            (prevTimeSheet) => id !== prevTimeSheet?.id
                        ),
                        totalItems: prev.totalItems - 1,
                    }))
                })
            })
        }, [baseRemove, authGet, userId, from, to, filters, refetch, setState]),
        isMyTimesheet ? "timeSheet.canDeleteMyTimesheet" : "timeSheet.canDelete",
    );

    const removeMany = useActionWithAccess(
        useCallback((ids, dates) => {
            baseRemoveMany(ids, dates, userId, async () => {
                return authGet(`/time-sheet/my-team`, {
                    params: {
                        ...formatTimeSheetParams({
                            from,
                            to,
                            filters
                        }),
                        userId,
                    },
                }).then( async (response) => {
                    await refetch(response);
                    setState((prev) => ({
                        ...prev,
                        data: prev?.data?.filter(
                            (prevTimeSheet) => !ids.includes(prevTimeSheet?.id)
                        ),
                        totalItems: prev.totalItems - ids.length,
                    }))
                })
            });
        }, [baseRemoveMany, authGet, refetch, filters, from, to, setState, userId]),
        isMyTimesheet ? "timeSheet.canDeleteMyTimesheet" : "timeSheet.canDelete",
    );


    const { modal, open } = useDeleteModal({
        message: (res) => {
            const { data } = res || {};
            const count = Array.isArray(data) ? data.length : 1;
            return t("do-you-want-to-delete-timesheets", { count });
        },
        permission: isMyTimesheet ? "timeSheet.canDeleteMyTimesheet" : "timeSheet.canDelete",
        onConfirm: (res) => {
            const { data, dates, userId } = res || {};
            return Array.isArray(data)
                ? removeMany(data, dates, userId)
                : removeOne(data)
        },
    });

    const remove = useActionWithAccess(open, isMyTimesheet ? "timeSheet.canDeleteMyTimesheet" : "timeSheet.canDelete");

    return { modal, remove };
}
